<template>
  <v-row>
    <DeleteRol
      :rol-id="selectedRolIdToDelete"
      v-model="isDeleteRolDialogVisible"
      @getRoles="getRoles()"
      @input="selectedRolIdToDelete = -1"
    />

    <NewEditRole v-model="showNewEditRoleDialog"
                 :method="method"
                 :selected-role="selectedRole" />

    <v-col cols="12" class="d-flex justify-end align-center pt-0">
      <v-btn color="mainButtons"
             dark
             @click="showNewRoleDialog()">
        {{ $t('general.addNew') }}
      </v-btn>
    </v-col>

    <v-col cols="12" class="text-h6 pb-0">
      <v-data-table fixed-header
                    :headers="headers"
                    :height="dataTableHeight"
                    :items="roles"
                    class="elevation-2"
                    :loading="loadingRoles"
                    :options.sync="options"
                    :footer-props="{
                        'items-per-page-text': 'Roles ' + $t('general.perPage'),
                        'items-per-page-options': [50, 100, 200]
                      }"
                    :server-items-length="totalRoles">
        <template v-slot:item="{ item }">
          <tr>
            <td class="font-weight-bold text-capitalize">{{ item.name.toLowerCase() }}</td>
            <td>{{ item.code }}</td>
            <td>
              <div class="d-flex justify-center align-center layout px-0 mx-0">
                <v-btn icon text @click="showEditRoleDialog(item)" color="kbDarkBlueText">
                  <v-icon color="kbDarkBlueText">edit</v-icon>
                </v-btn>

                <v-btn icon text @click="showDeleteRoleDialog(item.id)" color="kbRed">
                  <v-icon color="kbRed">mdi-delete</v-icon>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row>
            <v-col class="text-center" cols="12" v-if="loadingRoles">
              {{ $t('general.loading') }} roles
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              {{ $t('general.rolesNotCreated') }}
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import DeleteRol from '@/pages/App/Roles/dialogs/DeleteRol'
import NewEditRole from './dialogs/NewEditRole'
import ModuleTableHeight from '@/mixins/ModuleTableHeight'
export default {
  components: { DeleteRol, NewEditRole },
  computed: {
    ...mapState({
      loadingRoles: state => state.roles.loadingRoles,
      paginationRoles: state => state.roles.paginationRoles,
      selectedApp: state => state.apps.selectedApp,
      totalRoles: state => state.roles.totalRoles,
      roles: state => state.roles.roles
    }),
    headers () {
      return [
        { text: this.$t('general.nameOfTheRol'), value: 'name' },
        { text: this.$t('general.code'), value: 'code' },
        { text: this.$t('general.actions'), align: 'center', value: 'action', sortable: false }
      ]
    }
  },
  data () {
    return {
      isDeleteRolDialogVisible: false,
      method: 'create',
      options: {},
      selectedRole: {},
      selectedRolIdToDelete: -1,
      showNewEditRoleDialog: false
    }
  },
  methods: {
    showDeleteRoleDialog (rolId) {
      this.isDeleteRolDialogVisible = true
      this.selectedRolIdToDelete = rolId
    },
    showEditRoleDialog (rol) {
      this.method = 'edit'
      this.selectedRole = rol
      this.showNewEditRoleDialog = true
    },
    showNewRoleDialog () {
      this.method = 'create'
      this.selectedRole = {}
      this.showNewEditRoleDialog = true
    },
    getRoles () {
      this.$store.commit('SET_PAGINATION_ROLES', {
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        sortBy: this.options.sortBy[0],
        descending: this.options.sortDesc[0]
      })
      this.$store.dispatch('getRoles')
    }
  },
  mixins: [ModuleTableHeight],
  watch: {
    options: {
      handler () {
        this.getRoles()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    selectedApp () {
      this.$store.dispatch('getRoles')
    }
  }
}
</script>
